import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { FaCheckCircle, FaUserCheck, FaLeaf, FaHandshake } from "react-icons/fa";



// import Ico from './iconBox';

// import HomeBlog from '../assets/images/blog_1.jpg';
// import person1 from '../assets/images/person_1.jpg';
// import person2 from '../assets/images/person_2.jpg';
// import person3 from '../assets/images/person_3.jpg';
// import person4 from '../assets/images/person_4.jpg';



import Slider1 from '../img/Karachi-Travel-Guide-Travel-S-Helper-copy-1024x640.jpg';
import Slider2 from '../img/cover-image-2019-10-17T124521.228.jpg';





import smallReview1 from '../img/4 (1).jpg';
import smallReview2 from '../img/5 (1).jpg';
import smallReview3 from '../img/6 (1).jpg';


import About1 from '../img/hotel.jpg';
import About2 from '../img/Apartments.jpg';
import About3 from '../img/Home Stay.jpg';
import About4 from '../img/Hostels.jpg';


import Clifton from "./../img/clifton.jpg";
import Gulshan from "./../img/gulshan_karachi.jpg";
import Faisal from "./../img/Shahrah e Faisal.jpg";
import Malir from "./../img/malir.jpg";
import Tariq from "./../img/tariq-road.jpg";
import Saddar from "./../img/saddar-karachi.jpg";


import Offer1 from "./../img/offer-deal-1.png";
import Offer2 from "./../img/offer-deal-2.png";
import Offer3 from "./../img/offer-deal-3.png";



import BookingForm from "./BookingForm"
import PopularDestinations from "./Main_Website/PopularDestinations"
import BrowsePropertyType from "./Main_Website/BrowsePropertyType"
import TopUniqueProperties from "./Main_Website/TopUniqueProperties"
import ReviewSection from "./Main_Website/ReviewSection"


class Home extends Component {
    state = {

    }
    componentDidMount(){
        window.scrollTo(0, 0)

    }
    render() {
        return (
            <div>
            
       
















<>
  
  <div className="main position-relative">
    <div className="main_1">
      <section id="center" className="center_home px_4">
        <div className="container-fluid">
          <div className="row">
            <div
              id="carouselExampleCaptions"
              className="carousel slide"
              data-bs-ride="carousel"
            >
              <div className="carousel-inner" style={{height:"778px"}}>
                <div className="carousel-item active">
                  <img src={Slider1} className="d-block w-100" alt="..." />
                  <div className="carousel-caption d-md-block">
                    {/* <h6 className="d-inline-block bg_yellow text-white p-3 px-5 fs-5">
                      <i className="fa fa-map-location me-1" /> Karachi
                    </h6> */}
                    <h1 className="text-white font_70 mt-2" style={{fontSize:"43px"}}>
                      WHEN VERIFIED STAYS MATTER MOST,  <br /> GO WITH MOST TRUSTED.
                    </h1>
                    {/* <p className="mt-3 text-light">
                      Life is unpredictable, and we understand that plans might
                      change. Enjoy flexible booking options, so you can <br />{" "}
                      reschedule or modify your trip with ease.
                    </p>
                    <h6>
                      <span className="col_yellow">
                        <i className="fa fa-star" />
                        <i className="fa fa-star" />
                        <i className="fa fa-star" />
                        <i className="fa fa-star" />
                        <i className="fa fa-star-half-alt" />
                      </span>{" "}
                      4.5
                    </h6> */}
                    {/* <ul className="mb-0 mt-4">
                      <li className="d-inline-block">
                        <a className="button" href="#">
                          Book A Trip
                        </a>
                      </li>
                      <li className="d-inline-block ms-3 fw-bold">
                        <a className="text-white fs-4" href="#">
                          <i className="fa fa-umbrella-beach d-inline-block text-center rounded-circle bg_green fs-3 align-middle me-1" />{" "}
                          Tripadvisor
                        </a>
                      </li>
                    </ul> */}
                    <BookingForm/>
                  </div>
                </div>
                {/* <div className="carousel-item">
                  <img src={Slider2} className="d-block w-100" alt="..." />
                  <div className="carousel-caption d-md-block">
                  
                    <h1 className="text-white font_70 mt-2">
                      Journey and <br /> Discover Places.
                    </h1>
                    <p className="mt-3 text-light">
                      Life is unpredictable, and we understand that plans might
                      change. Enjoy flexible booking options, so you can <br />{" "}
                      reschedule or modify your trip with ease.
                    </p>
                    <h6>
                      <span className="col_yellow">
                        <i className="fa fa-star" />
                        <i className="fa fa-star" />
                        <i className="fa fa-star" />
                        <i className="fa fa-star" />
                        <i className="fa fa-star-half-alt" />
                      </span>{" "}
                      4.5
                    </h6>
                    <ul className="mb-0 mt-4">
                      <li className="d-inline-block">
                        <a className="button" href="#">
                          Book A Trip
                        </a>
                      </li>
                    
                    </ul>
                  </div>
                </div>
                <div className="carousel-item">
                  <img src="img/3.jpg" className="d-block w-100" alt="..." />
                  <div className="carousel-caption d-md-block">
                   
                    <h1 className="text-white font_70 mt-2">
                      Trek and Venture <br /> to a Spot.
                    </h1>
                    <p className="mt-3 text-light">
                      Life is unpredictable, and we understand that plans might
                      change. Enjoy flexible booking options, so you can <br />{" "}
                      reschedule or modify your trip with ease.
                    </p>
                    <h6>
                      <span className="col_yellow">
                        <i className="fa fa-star" />
                        <i className="fa fa-star" />
                        <i className="fa fa-star" />
                        <i className="fa fa-star" />
                        <i className="fa fa-star-half-alt" />
                      </span>{" "}
                      4.5
                    </h6>
                    <ul className="mb-0 mt-4">
                      <li className="d-inline-block">
                        <a className="button" href="#">
                          Book A Trip
                        </a>
                      </li>
                     
                    </ul>
                  </div>
                </div> */}
              </div>
              <button
                className="carousel-control-prev"
                type="button"
                data-bs-target="#carouselExampleCaptions"
                data-bs-slide="prev"
              >
                <span
                  className="carousel-control-prev-icon"
                  aria-hidden="true"
                />
                <span className="visually-hidden">Previous</span>
              </button>
              <button
                className="carousel-control-next"
                type="button"
                data-bs-target="#carouselExampleCaptions"
                data-bs-slide="next"
              >
                <span
                  className="carousel-control-next-icon"
                  aria-hidden="true"
                />
                <span className="visually-hidden">Next</span>
              </button>
            </div>
          </div>
        </div>
      </section>
    </div>
    
  </div>



























           
           
           
<PopularDestinations />






<section id="about_yovho_modern" className="aboutModern_section">
  <div className="container-xl">
    <div className="row align-items-center">
      {/* Left Content */}
      <div className="col-md-6">
        <div className="aboutModern_left">
          <h5 className="aboutModern_tag">
            <i className="fa fa-leaf me-1" /> About YOVHO{" "}
            <i className="fa fa-leaf ms-1" />
          </h5>

          <h2 className="aboutModern_title">
            Verified Stays That Feel Like Home — Every Time
          </h2>

          <div className="aboutModern_tabs">
            <button className="aboutModern_tab active">Mission & Vision</button>
            <button className="aboutModern_tab">Focus On Customer</button>
          </div>

          <div className="aboutModern_text">
            <p>
              At <strong>YOVHO</strong>, we’re redefining the stay experience by
              bringing verified hotels, apartments, homestays, and hostels together on
              one trusted platform.  
              Our mission is to make finding a safe, reliable, and affordable stay
              effortless for every traveler.
            </p>
          </div>

          <div className="aboutModern_actions d-flex align-items-center mt-4">
            <a href="/about-us" className="aboutModern_btn">Learn More</a>
            <div className="aboutModern_avatars ms-3">
              <img src={smallReview1} alt="customer" />
              <img src={smallReview2} alt="customer" />
              <img src={smallReview3} alt="customer" />
              <span className="aboutModern_counter">
                <strong>3K+</strong> <br /> Happy Guests
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Right Images */}
      <div className="col-md-6" style={{marginTop:"30px"}}>
        <div className="aboutModern_right">
          <div className="aboutModern_gallery">
            <div className="aboutModern_column">
              <img src={About1} alt="Stay" />
              <img src={About2} alt="Apartment" />
            </div>
            <div className="aboutModern_column">
              <img src={About3} alt="Room" />
              <img src={About4} alt="Hotel" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>






<BrowsePropertyType />




 <section id="whyYovho" className="whyYovho-section">
  <div className="whyYovho-container">
    <div className="whyYovho-content">
      {/* LEFT TEXT SECTION */}
      <div className="whyYovho-left">
        <h5 className="whyYovho-subtitle">
          <i className="fa fa-leaf me-2" /> Why Choose Yovho{" "}
          <i className="fa fa-leaf ms-2" />
        </h5>
        <h2 className="whyYovho-heading">
          Verified Stays <br /> You Can Trust
        </h2>
        <p className="whyYovho-description">
          At <strong>Yovho.com</strong>, we make booking your next stay simple,
          safe, and reliable. Every property is <strong>verified by guests</strong> to
          ensure comfort, security, and peace of mind — every time you travel.
        </p>

        <div className="whyYovho-features">
          <div className="whyYovho-feature">
            <i className="fa fa-shield-alt"></i> Verified Properties Only
          </div>
          <div className="whyYovho-feature">
            <i className="fa fa-clock"></i> 24/7 Booking Support
          </div>
          <div className="whyYovho-feature">
            <i className="fa fa-lock"></i> Easy & Secure Payments
          </div>
          <div className="whyYovho-feature">
            <i className="fa fa-check-circle"></i> Real-Time Availability
          </div>
          <div className="whyYovho-feature">
            <i className="fa fa-star"></i> Verified Guest Reviews
          </div>
          <div className="whyYovho-feature">
            <i className="fa fa-map-marker-alt"></i> Local Experience & Guidance
          </div>
        </div>
      </div>

      {/* RIGHT CARDS SECTION */}
      <div className="whyYovho-right">
        <div className="whyYovho-card glow">
          <h5>Overall Guest Rating</h5>
          <h2 className="whyYovho-score">4.8</h2>
          <div className="whyYovho-stars">
            <i className="fa fa-star"></i>
            <i className="fa fa-star"></i>
            <i className="fa fa-star"></i>
            <i className="fa fa-star"></i>
            <i className="fa fa-star-half-alt"></i>
          </div>
          <p>Based on 15,240 verified guest reviews</p>
        </div>

        <div className="whyYovho-card">
          <h5>Customer Experience</h5>
          <p className="whyYovho-quote">
            “When verified stays matter most, go with the most trusted.”
          </p>
          <div className="whyYovho-ratingBreakdown">
            <div className="whyYovho-box">
              <h3>4.9</h3>
              <p>Guest Satisfaction</p>
            </div>
            <ul className="whyYovho-list">
              <li>⭐ 5 Star — 9,800</li>
              <li>⭐ 4 Star — 3,100</li>
              <li>⭐ 3 Star — 1,200</li>
              <li>⭐ 2 Star — 600</li>
              <li>⭐ 1 Star — 300</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

  
  
  

  

 {/* <section id="vacation" className="p_3">
      <div className="container-xl">
        <div className="row vacation_1 text-center mb-4">
          <div className="col-md-12">
            <h5 className="family_1 icon_tag col_green">
              <i className="fa fa-leaf me-1" /> Explore Karachi with{" "}
              <i className="fa fa-leaf ms-1" />
            </h5>
            <h2 className="font_50 mt-3 mb-0">Top Verified Stay Locations</h2>
          </div>
        </div>

        <div className="row vacation_2">
          <div className="col-md-3">
            <div className="vacation_2i position-relative">
              <div className="vacation_2i1">
                <img src={Clifton} alt="Clifton Karachi" className="rounded_1 w-100" />
              </div>
              <div className="vacation_2i2 text-center position-absolute bottom-0 w-100 h-100 px-3 bg_back">
                <h3 className="mb-0 text-white">Clifton</h3>
              </div>
              <div className="vacation_2i3 text-center position-absolute top-0 w-100 h-100 bg_back px-3">
                <h3 className="mb-0">
                  <a className="text-white a_tag1" href="#">
                    Premium Beach Hotels
                  </a>
                </h3>
                <hr className="line mx-auto" />
                <h6 className="d-inline-block bg_green text-white p-2 px-4">8+ Verified Stays</h6>
              </div>
            </div>
          </div>

          <div className="col-md-6">
            <div className="vacation_2i position-relative">
              <div className="vacation_2i1">
                <img src={Gulshan} alt="Gulshan e Iqbal" className="rounded_1 w-100" />
              </div>
              <div className="vacation_2i2 vacation_2i2o text-center position-absolute bottom-0 w-100 h-100 px-3 bg_back">
                <h3 className="mb-0 text-white">Gulshan-e-Iqbal</h3>
              </div>
              <div className="vacation_2i3 vacation_2i3o text-center position-absolute top-0 w-100 h-100 bg_back px-3">
                <h3 className="mb-0">
                  <a className="text-white a_tag1" href="#">
                    Affordable Family Apartments
                  </a>
                </h3>
                <hr className="line mx-auto" />
                <h6 className="d-inline-block bg_green text-white p-2 px-4">12+ Verified Stays</h6>
              </div>
            </div>
          </div>

          <div className="col-md-3">
            <div className="vacation_2i position-relative">
              <div className="vacation_2i1">
                <img src={Faisal} alt="Shahrah e Faisal" className="rounded_1 w-100" />
              </div>
              <div className="vacation_2i2 text-center position-absolute bottom-0 w-100 h-100 px-3 bg_back">
                <h3 className="mb-0 text-white">Shahrah-e-Faisal</h3>
              </div>
              <div className="vacation_2i3 text-center position-absolute top-0 w-100 h-100 bg_back px-3">
                <h3 className="mb-0">
                  <a className="text-white a_tag1" href="#">
                    Business Hotels & Suites
                  </a>
                </h3>
                <hr className="line mx-auto" />
                <h6 className="d-inline-block bg_green text-white p-2 px-4">10+ Verified Stays</h6>
              </div>
            </div>
          </div>
        </div>

        <div className="row vacation_2 mt-4">
          <div className="col-md-3">
            <div className="vacation_2i position-relative">
              <div className="vacation_2i1">
                <img src={Malir} alt="Malir" className="rounded_1 w-100" />
              </div>
              <div className="vacation_2i2 text-center position-absolute bottom-0 w-100 h-100 px-3 bg_back">
                <h3 className="mb-0 text-white">Malir</h3>
              </div>
              <div className="vacation_2i3 text-center position-absolute top-0 w-100 h-100 bg_back px-3">
                <h3 className="mb-0">
                  <a className="text-white a_tag1" href="#">
                    Cozy Family Guesthouses
                  </a>
                </h3>
                <hr className="line mx-auto" />
                <h6 className="d-inline-block bg_green text-white p-2 px-4">6+ Verified Stays</h6>
              </div>
            </div>
          </div>

          <div className="col-md-6">
            <div className="vacation_2i position-relative">
              <div className="vacation_2i1">
                <img src={Tariq} alt="Tariq Road" className="rounded_1 w-100" />
              </div>
              <div className="vacation_2i2 vacation_2i2o text-center position-absolute bottom-0 w-100 h-100 px-3 bg_back">
                <h3 className="mb-0 text-white">Tariq Road</h3>
              </div>
              <div className="vacation_2i3 vacation_2i3o text-center position-absolute top-0 w-100 h-100 bg_back px-3">
                <h3 className="mb-0">
                  <a className="text-white a_tag1" href="#">
                    Boutique Hotels & Modern Rooms
                  </a>
                </h3>
                <hr className="line mx-auto" />
                <h6 className="d-inline-block bg_green text-white p-2 px-4">9+ Verified Stays</h6>
              </div>
            </div>
          </div>

          <div className="col-md-3">
            <div className="vacation_2i position-relative">
              <div className="vacation_2i1">
                <img src={Saddar} alt="Saddar Karachi" className="rounded_1 w-100" />
              </div>
              <div className="vacation_2i2 text-center position-absolute bottom-0 w-100 h-100 px-3 bg_back">
                <h3 className="mb-0 text-white">Saddar</h3>
              </div>
              <div className="vacation_2i3 text-center position-absolute top-0 w-100 h-100 bg_back px-3">
                <h3 className="mb-0">
                  <a className="text-white a_tag1" href="#">
                    Budget Hotels & Hostels
                  </a>
                </h3>
                <hr className="line mx-auto" />
                <h6 className="d-inline-block bg_green text-white p-2 px-4">7+ Verified Stays</h6>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section> */}




<TopUniqueProperties />













<section id="about_pg" className="p-3">
  <div className="container-xl">

    {/* Stats Section */}
    <div className="row aboutStats_section mt-5 pt-4 pb-4">
      <div className="col-md-3 col-sm-6">
        <div className="aboutStats_item">
          <div className="aboutStats_inner row">
            <div className="col-md-3">
              <div className="aboutStats_iconBox">
                <span className="col_green font_50 lh-1">
                  <i className="fa fa-building" style={{color: "#19a529"}} />
                </span>
              </div>
            </div>
            <div className="col-md-9">
              <div className="aboutStats_text">
                <h3 className="mb-1">1.2k+</h3>
                <h6 className="mb-0">Listed Properties</h6>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="col-md-3 col-sm-6">
        <div className="aboutStats_item">
          <div className="aboutStats_inner row">
            <div className="col-md-3">
              <div className="aboutStats_iconBox">
                <span className="col_green font_50 lh-1">
                  <i className="fa fa-users" style={{color: "#19a529"}} />
                </span>
              </div>
            </div>
            <div className="col-md-9">
              <div className="aboutStats_text">
                <h3 className="mb-1">3.5k+</h3>
                <h6 className="mb-0">Satisfied Clients</h6>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="col-md-3 col-sm-6">
        <div className="aboutStats_item">
          <div className="aboutStats_inner row">
            <div className="col-md-3">
              <div className="aboutStats_iconBox">
                <span className="col_green font_50 lh-1">
                  <i className="fa fa-star" style={{color: "#19a529"}} />
                </span>
              </div>
            </div>
            <div className="col-md-9">
              <div className="aboutStats_text">
                <h3 className="mb-1">4.9</h3>
                <h6 className="mb-0">Average Rating</h6>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="col-md-3 col-sm-6">
        <div className="aboutStats_item border-end-0">
          <div className="aboutStats_inner row">
            <div className="col-md-3">
              <div className="aboutStats_iconBox">
                <span className="col_green font_50 lh-1">
                  <i className="fa fa-handshake" style={{color: "#19a529"}} />
                </span>
              </div>
            </div>
            <div className="col-md-9">
              <div className="aboutStats_text">
                <h3 className="mb-1">850+</h3>
                <h6 className="mb-0">Successful Deals</h6>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    {/* Rating Section */}
    <div className="row aboutRating_section mt-4 text-center">
      <div className="col-md-12">
        <p className="mb-0">
          <span className="fw-bold">Trusted by Thousands!</span>
          <span className="fw-bold ms-2">4.9</span> Rating out of
          <span className="fw-bold">5.0</span> based on
          <a href="#"> <span className="fw-bold">18,764</span> reviews</a>
          <span className="ms-2 fw-bold">
            <i className="fa fa-check-circle col_green" /> Verified Platform
          </span>
        </p>
      </div>
    </div>

  </div>
</section>









 (
    <section id="dealSection" className="dealSection_wrapper">
      <div className="container-xl">
        <div className="dealSection_header text-center mb-5">
          <h5 className="dealSection_tag">
            <i className="fa fa-leaf me-2" />
            Hurry Up
            <i className="fa fa-leaf ms-2" />
          </h5>
          <h2 className="dealSection_title">Phenomenal Deals Offered</h2>
          <p className="dealSection_subtitle">
            Hand-picked travel experiences with up to 40% off — only for a limited time.
          </p>
        </div>

        <div className="row g-4 justify-content-center">
          {/* Card 1 */}
          <div className="col-md-4 col-lg-3">
            <div className="dealCard_item" style={{height:"230px"}}>
              <img src={Offer1} alt="Offer 1" className="dealCard_image" />
              <div className="dealCard_overlay">
                <h5 className="dealCard_label">Savings Worldwide</h5>
                <h2 className="dealCard_discount">20% Off</h2>
              </div>
            </div>
          </div>

          {/* Card 2 */}
          <div className="col-md-6 col-lg-5">
            <div className="dealCard_item large">
              <img src={Offer2} alt="Offer 2" className="dealCard_image" />
              <div className="dealCard_overlay">
                <h5 className="dealCard_label">Honeymoon Tour</h5>
                <h4 className="dealCard_text">
                  Enjoy <span className="dealCard_highlight">40%</span> Off
                </h4>
                {/* <p className="dealCard_subtext">2 Countries • 15 Locations</p> */}
              </div>
            </div>
          </div>

          {/* Card 3 */}
          <div className="col-md-4 col-lg-3">
            <div className="dealCard_item" style={{height:"230px"}}>
              <img src={Offer3} alt="Offer 3" className="dealCard_image" />
              <div className="dealCard_overlay">
                <h5 className="dealCard_label">Couple Tour</h5>
                <h2 className="dealCard_discount">30% Off</h2>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>









 {/* <section id="offer" className="p_3 pt-0">
    <div className="container-xl">
      <div className="row vacation_1 text-center mb-4">
        <div className="col-md-12">
          <h5 className="family_1 icon_tag col_green">
            <i className="fa fa-leaf me-1" /> Hurry Up{" "}
            <i className="fa fa-leaf ms-1" />
          </h5>
          <h2 className="font_50 mt-3 mb-0">Phenomenal Deals Offered</h2>
        </div>
      </div>
      <div className="row offer_1">
        <div className="col-md-3">
          <div className="offer_1l position-relative">
            <div className="offer_1li">
              <div className="grid clearfix">
                <figure className="effect-jazz mb-0">
                  <a href="#">
                    <img src={Offer1} className="w-100" alt="img25" />
                  </a>
                </figure>
              </div>
            </div>
            <div className="offer_1li1 position-absolute p-4 px-3 bottom-0 w-100 text-center">
              <h5 className="family_1 text-white">Savings worldwide</h5>
              <h2 className="col_yellow">20% Off</h2>
             
            </div>
          </div>
        </div>
        <div className="col-md-6">
          <div className="offer_1l position-relative">
            <div className="offer_1li">
              <div className="grid clearfix">
                <figure className="effect-jazz mb-0">
                  <a href="#">
                    <img src={Offer2} className="w-100" alt="img25" />
                  </a>
                </figure>
              </div>
            </div>
            <div className="offer_1li1 position-absolute p-4 px-3 bottom-0 w-100 text-center">
              <h5 className="family_1 text-white">Honeymoon Tour</h5>
              <h4 className="text-white">
                Enjoy <span className="col_yellow fs-2">40%</span> Off
              </h4>
              <h6 className="text-white">2 Country &amp; 15 Location</h6>
             
            </div>
          </div>
        </div>
        <div className="col-md-3">
          <div className="offer_1l position-relative">
            <div className="offer_1li">
              <div className="grid clearfix">
                <figure className="effect-jazz mb-0">
                  <a href="#">
                    <img src={Offer3} className="w-100" alt="img25" />
                  </a>
                </figure>
              </div>
            </div>
            <div className="offer_1li1 position-absolute p-4 px-3 bottom-0 w-100 text-center">
              <h5 className="family_1 text-white">Couple Tour</h5>
              <h2 className="col_yellow">30% Off</h2>
             
            </div>
          </div>
        </div>
      </div>
      
    </div>
  </section>
 */}



<ReviewSection />















  {/* <section id="expe" className="p_3">
    <div className="container-xl">
      <div className="row vacation_1 text-center mb-4">
        <div className="col-md-12">
          <h5 className="family_1 icon_tag col_green">
            <i className="fa fa-leaf me-1" /> Tour Experience{" "}
            <i className="fa fa-leaf ms-1" />
          </h5>
          <h2 className="font_50 mt-3 mb-0">Ultimate Travel Experience</h2>
        </div>
      </div>
      <div className="row expe_1 mb-4">
        <div className="col-md-12">
          <ul className="nav nav-tabs mb-4 border-0 justify-content-center">
          </ul>
          <div className="tab-content">
            <div className="tab-pane active" id="profile7">
              <div className="profile7i row">
                <div className="col-md-6">
                  <div className="profile7il border_1">
                    <div className="profile7il1 position-relative">
                      <div className="profile7il1i">
                        <div className="grid clearfix">
                          <figure className="effect-jazz mb-0">
                            <a href="#">
                              <img
                                src="img/23.jpg"
                                className="w-100 rounded-0"
                                alt="img25"
                              />
                            </a>
                          </figure>
                        </div>
                      </div>
                      <div className="profile7il1i1 position-absolute top-0">
                        <h6 className="d-inline-block bg_green text-white p-2 px-4">
                          {" "}
                          Breakfast Included
                        </h6>
                      </div>
                    </div>
                    <div className="profile7il2 p-4">
                      <h4>
                        <a href="#">Eclipse Haven Lodge</a>
                      </h4>
                      <p className="font_14 lh-base">
                        <i className="fa fa-map-marker col_green me-1" /> House
                        128/140, Road 01, Avenue 02, Lorem DPHS, Amet, India -
                        See Map 1 km to city center
                      </p>
                      <ul className="font_14">
                        <li className="d-inline-block">
                          <i className="fa fa-tv me-1 col_green align-middle" />{" "}
                          TV
                        </li>
                        <li className="d-inline-block ms-2">
                          <i className="fa fa-temperature-up me-1 col_green align-middle" />{" "}
                          Heater
                        </li>
                        <li className="d-inline-block ms-2">
                          <i className="fa fa-lock me-1 col_green align-middle" />{" "}
                          Saving Safe
                        </li>
                        <li className="d-inline-block ms-2">
                          <i className="fa fa-wifi me-1 col_green align-middle" />{" "}
                          Free Wifi
                        </li>
                        <li className="d-inline-block ms-2">
                          <i className="fa fa-phone me-1 col_green align-middle" />{" "}
                          Phone
                        </li>
                      </ul>
                      <div className="profile7il2i row">
                        <div className="col-md-6">
                          <div className="profile7il2il">
                            <h5 className="font_15">
                              Sea View
                              <br />
                              Semi Double
                              <br />
                              <span className="fw-normal">1 king bed</span>
                            </h5>
                            <h6 className="mb-0 font_15">
                              <span className="fw-bold col_green">
                                Free cancellation
                              </span>
                              <br />
                              before 48 hours
                            </h6>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="profile7il2ir text-end">
                            <h6 className="font_14 mb-0">
                              1 Night, 2 Adults
                              <br />
                              <span className="fw-bold">
                                <span className="fs-4 col_green">$340</span>{" "}
                                <span className="text-decoration-line-through text-muted">
                                  $450
                                </span>
                              </span>
                              <br />
                            </h6>
                            <h6 className="mb-0 mt-2">
                              <a className="button px-3" href="#">
                                Check Availability{" "}
                                <i className="fa fa-arrow-right align-middle" />
                              </a>
                            </h6>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="profile7il border_1">
                    <div className="profile7il1 position-relative">
                      <div className="profile7il1i">
                        <div className="grid clearfix">
                          <figure className="effect-jazz mb-0">
                            <a href="#">
                              <img
                                src="img/24.jpg"
                                className="w-100 rounded-0"
                                alt="img25"
                              />
                            </a>
                          </figure>
                        </div>
                      </div>
                      <div className="profile7il1i1 position-absolute top-0">
                        <h6 className="d-inline-block bg_green text-white p-2 px-4">
                          {" "}
                          Breakfast Included
                        </h6>
                      </div>
                    </div>
                    <div className="profile7il2 p-4">
                      <h4>
                        <a href="#">Twilight Serenity Manor</a>
                      </h4>
                      <p className="font_14 lh-base">
                        <i className="fa fa-map-marker col_green me-1" /> House
                        128/140, Road 01, Avenue 02, Lorem DPHS, Amet, India -
                        See Map 1 km to city center
                      </p>
                      <ul className="font_14">
                        <li className="d-inline-block">
                          <i className="fa fa-tv me-1 col_green align-middle" />{" "}
                          TV
                        </li>
                        <li className="d-inline-block ms-2">
                          <i className="fa fa-temperature-up me-1 col_green align-middle" />{" "}
                          Heater
                        </li>
                        <li className="d-inline-block ms-2">
                          <i className="fa fa-lock me-1 col_green align-middle" />{" "}
                          Saving Safe
                        </li>
                        <li className="d-inline-block ms-2">
                          <i className="fa fa-wifi me-1 col_green align-middle" />{" "}
                          Free Wifi
                        </li>
                        <li className="d-inline-block ms-2">
                          <i className="fa fa-phone me-1 col_green align-middle" />{" "}
                          Phone
                        </li>
                      </ul>
                      <div className="profile7il2i row">
                        <div className="col-md-6">
                          <div className="profile7il2il">
                            <h5 className="font_15">
                              Sea View
                              <br />
                              Semi Double
                              <br />
                              <span className="fw-normal">1 king bed</span>
                            </h5>
                            <h6 className="mb-0 font_15">
                              <span className="fw-bold col_green">
                                Free cancellation
                              </span>
                              <br />
                              before 48 hours
                            </h6>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="profile7il2ir text-end">
                            <h6 className="font_14 mb-0">
                              1 Night, 2 Adults
                              <br />
                              <span className="fw-bold">
                                <span className="fs-4 col_green">$230</span>{" "}
                                <span className="text-decoration-line-through text-muted">
                                  $320
                                </span>
                              </span>
                              <br />
                            </h6>
                            <h6 className="mb-0 mt-2">
                              <a className="button px-3" href="#">
                                Check Availability{" "}
                                <i className="fa fa-arrow-right align-middle" />
                              </a>
                            </h6>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              
            </div>
            
          </div>
        </div>
      </div>
    </div>
  </section> */}

 
  
  
  
  
  <section class="why-choose-yovho">
  <div class="why-container">
    <div class="why-header">
      <h5><i class="fa fa-leaf"></i> Our Promise <i class="fa fa-leaf"></i></h5>
      <h2>Why Choose <span>Yovho</span></h2>
      <p>
        Discover what makes Yovho your trusted travel companion — where comfort,
        confidence, and convenience meet.
      </p>
    </div>

    <div class="why-grid">
      <div class="why-card">
        <div class="icon"><i class="fa fa-globe"></i></div>
        <h3>Verified Properties</h3>
        <p>
          Every stay listed on Yovho — from hotels to hostels — is verified for
          safety, comfort, and reliability, so you can book with complete
          confidence.
        </p>
      </div>

      <div class="why-card">
        <div class="icon"><i class="fa fa-dollar-sign"></i></div>
        <h3>Best Price Guarantee</h3>
        <p>
          Enjoy competitive rates on every booking. Yovho partners directly with
          verified hosts to offer transparent and fair prices — no hidden fees.
        </p>
      </div>

      <div class="why-card">
        <div class="icon"><i class="fa fa-calendar-check"></i></div>
        <h3>Instant Booking</h3>
        <p>
          With real-time availability and instant confirmations, booking your next
          stay is smooth, fast, and hassle-free.
        </p>
      </div>

      <div class="why-card">
        <div class="icon"><i class="fa fa-user-shield"></i></div>
        <h3>Trusted Community</h3>
        <p>
          Thousands of verified travelers and hosts trust Yovho. Real reviews.
          Real experiences. Real peace of mind.
        </p>
      </div>

      <div class="why-card">
        <div class="icon"><i class="fa fa-headset"></i></div>
        <h3>24/7 Guest Support</h3>
        <p>
          Our team is always available to assist — before, during, and after your
          stay — ensuring a stress-free experience.
        </p>
      </div>

      <div class="why-card">
        <div class="icon"><i class="fa fa-sync-alt"></i></div>
        <h3>Flexible Stays</h3>
        <p>
          From one night to long-term stays, Yovho offers flexible booking options
          tailored to your needs and comfort.
        </p>
      </div>
    </div>
  </div>
</section>



  {/* <section id="choose" className="p_3">
  <div className="container-xl">
    <div className="row vacation_1 text-center mb-4">
      <div className="col-md-12">
        <h5 className="family_1 icon_tag col_green">
          <i className="fa fa-leaf me-1" /> Our Promise{" "}
          <i className="fa fa-leaf ms-1" />
        </h5>
        <h2 className="font_50 mt-3 mb-0">Why Choose Yovho</h2>
      </div>
    </div>

    <div className="row choose_1">
      <div className="col-md-4">
        <div className="choose_1l p-4 px-3 bg_light border_1 rounded_1">
          <div className="choose_1li row">
            <div className="col-md-4">
              <div className="choose_1lil">
                <span className="d-inline-block bg_light1 text-center rounded-circle text-center">
                  <i className="fa fa-globe" />
                </span>
              </div>
            </div>
            <div className="col-md-8">
              <div className="choose_1lir">
                <h5>Verified Properties</h5>
                <p className="mb-0">
                  Every stay listed on Yovho — from hotels to hostels — is
                  verified for safety, comfort, and reliability, so you can book
                  with complete confidence.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="col-md-4">
        <div className="choose_1l p-4 px-3 bg_light1 border_1 rounded_1">
          <div className="choose_1li row">
            <div className="col-md-4">
              <div className="choose_1lil">
                <span className="d-inline-block bg_light text-center rounded-circle text-center">
                  <i className="fa fa-dollar" />
                </span>
              </div>
            </div>
            <div className="col-md-8">
              <div className="choose_1lir">
                <h5>Best Price Guarantee</h5>
                <p className="mb-0">
                  Enjoy competitive rates on every booking. Yovho partners
                  directly with verified hosts to offer transparent and fair
                  prices — no hidden fees.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="col-md-4">
        <div className="choose_1l p-4 px-3 bg_light border_1 rounded_1">
          <div className="choose_1li row">
            <div className="col-md-4">
              <div className="choose_1lil">
                <span className="d-inline-block bg_light1 text-center rounded-circle text-center">
                  <i className="fa fa-calendar" />
                </span>
              </div>
            </div>
            <div className="col-md-8">
              <div className="choose_1lir">
                <h5>Instant Booking</h5>
                <p className="mb-0">
                  With real-time availability and instant confirmations,
                  booking your next stay is smooth, fast, and hassle-free.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div className="row choose_1 mt-4">
      <div className="col-md-4">
        <div className="choose_1l p-4 px-3 bg_light border_1 rounded_1">
          <div className="choose_1li row">
            <div className="col-md-4">
              <div className="choose_1lil">
                <span className="d-inline-block bg_light1 text-center rounded-circle text-center">
                  <i className="fa fa-user-plus" />
                </span>
              </div>
            </div>
            <div className="col-md-8">
              <div className="choose_1lir">
                <h5>Trusted Community</h5>
                <p className="mb-0">
                  Thousands of verified travelers and hosts trust Yovho. Real
                  reviews. Real experiences. Real peace of mind.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="col-md-4">
        <div className="choose_1l p-4 px-3 bg_light1 border_1 rounded_1">
          <div className="choose_1li row">
            <div className="col-md-4">
              <div className="choose_1lil">
                <span className="d-inline-block bg_light text-center rounded-circle text-center">
                  <i className="fa fa-phone" />
                </span>
              </div>
            </div>
            <div className="col-md-8">
              <div className="choose_1lir">
                <h5>24/7 Guest Support</h5>
                <p className="mb-0">
                  Our team is always available to assist — before, during, and
                  after your stay — ensuring a stress-free experience.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="col-md-4">
        <div className="choose_1l p-4 px-3 bg_light border_1 rounded_1">
          <div className="choose_1li row">
            <div className="col-md-4">
              <div className="choose_1lil">
                <span className="d-inline-block bg_light1 text-center rounded-circle text-center">
                  <i className="fa fa-recycle" />
                </span>
              </div>
            </div>
            <div className="col-md-8">
              <div className="choose_1lir">
                <h5>Flexible Stays</h5>
                <p className="mb-0">
                  From one night to long-term stays, Yovho offers flexible
                  booking options tailored to your needs and comfort.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section> */}

  {/* <section id="popular" className="p_3 bg_light1">
    <div className="container-xl">
      <div className="row vacation_1 text-center mb-4">
        <div className="col-md-12">
          <h5 className="family_1 icon_tag col_green">
            <i className="fa fa-leaf me-1" /> Popular Tour{" "}
            <i className="fa fa-leaf ms-1" />
          </h5>
          <h2 className="font_50 mt-3 mb-0">Elite Tourist Attractions</h2>
        </div>
      </div>
      <div className="row popular_1 text-center mb-4 expe_1 ">
        <div className="col-md-12">
          <ul className="nav nav-tabs mb-4 border-0 justify-content-center">
            <li className="nav-item d-inline-block">
              <a
                href="#profile9"
                data-bs-toggle="tab"
                aria-expanded="true"
                className="nav-link active"
              >
                <span className="d-md-block"> karachi</span>
              </a>
            </li>
            <li className="nav-item d-inline-block">
              <a
                href="#profile10"
                data-bs-toggle="tab"
                aria-expanded="true"
                className="nav-link"
              >
                <span className="d-md-block"> Gulshan e Iqbal</span>
              </a>
            </li>
            <li className="nav-item d-inline-block">
              <a
                href="#profile11"
                data-bs-toggle="tab"
                aria-expanded="true"
                className="nav-link"
              >
                <span className="d-md-block"> Shahrah e Faisal</span>
              </a>
            </li>
            <li className="nav-item d-inline-block">
              <a
                href="#profile12"
                data-bs-toggle="tab"
                aria-expanded="true"
                className="nav-link"
              >
                <span className="d-md-block"> Malir</span>
              </a>
            </li>
            <li className="nav-item d-inline-block">
              <a
                href="#profile13"
                data-bs-toggle="tab"
                aria-expanded="true"
                className="nav-link"
              >
                <span className="d-md-block"> Tariq Road</span>
              </a>
            </li>
          </ul>
          <div className="tab-content">
            <div className="tab-pane active" id="profile9">
              <div className="profile6i row">
                <div className="col-md-4">
                  <div className="profile6il p-3 shadow_box rounded_1">
                    <div className="profile6il1 position-relative">
                      <div className="profile6il1i">
                        <a href="#">
                          <img
                            src="img/17.jpg"
                            alt="abc"
                            className="w-100 rounded_1"
                          />
                        </a>
                      </div>
                      <div className="profile6il1i1 position-absolute top-0">
                        <h6 className="d-inline-block bg-black text-white p-2 px-3 font_14 mb-0">
                          {" "}
                          1 WEEK
                        </h6>
                        <br />
                        <h6 className="d-inline-block bg_light p-2 px-3 font_14  mb-0">
                          <a href="#">
                            <i className="fa fa-map-marker me-1 col_green" />{" "}
                            EGYPT
                          </a>
                        </h6>
                      </div>
                    </div>
                    <div className="profile6il2 mt-3">
                      <h5>
                        <a href="#">
                          Discover Serenity, Exploration, And Enlightenment.
                        </a>
                      </h5>
                      <ul className="font_12">
                        <li className="d-inline-block me-1">
                          <a href="#">LOREM PORTA</a>
                        </li>
                        <li className="d-inline-block me-1">
                          <i className="fa fa-arrow-right" />
                        </li>
                        <li className="d-inline-block me-1">
                          <a href="#">SEA BEACH</a>
                        </li>
                        <li className="d-inline-block me-1">
                          <i className="fa fa-arrow-right" />
                        </li>
                        <li className="d-inline-block me-1">
                          <a href="#">IPSUM WORLD</a>
                        </li>
                      </ul>
                      <hr />
                      <div className="profile6il2i row">
                        <div className="col-md-6">
                          <div className="profile6il2il">
                            <h6 className="font_14 mb-0">
                              Starting From:
                              <br />
                              <span className="fw-bold">
                                <span className="fs-4 col_green">$340</span>{" "}
                                <span className="text-decoration-line-through text-muted">
                                  $450
                                </span>
                              </span>
                              <br />
                              <span className="font_12">TAXES INCL/PERS</span>
                            </h6>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="profile6il2ir text-end pt-2">
                            <h6 className="mb-0">
                              <a className="button px-3" href="#">
                                Book A Trip <i className="fa fa-plane" />
                              </a>
                            </h6>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="profile6il p-3 shadow_box rounded_1">
                    <div className="profile6il1 position-relative">
                      <div className="profile6il1i">
                        <a href="#">
                          <img
                            src="img/18.jpg"
                            alt="abc"
                            className="w-100 rounded_1"
                          />
                        </a>
                      </div>
                      <div className="profile6il1i1 position-absolute top-0">
                        <h6 className="d-inline-block bg-black text-white p-2 px-3 font_14 mb-0">
                          {" "}
                          2 DAYS / 3 NIGHT
                        </h6>
                        <br />
                        <h6 className="d-inline-block bg_light p-2 px-3 font_14  mb-0">
                          <a href="#">
                            <i className="fa fa-map-marker me-1 col_green" />{" "}
                            Spain
                          </a>
                        </h6>
                      </div>
                    </div>
                    <div className="profile6il2 mt-3">
                      <h5>
                        <a href="#">
                          Embracing City Lights, Landm, And Iconic Culture.
                        </a>
                      </h5>
                      <ul className="font_12">
                        <li className="d-inline-block me-1">
                          <a href="#">LOREM PORTA</a>
                        </li>
                        <li className="d-inline-block me-1">
                          <i className="fa fa-arrow-right" />
                        </li>
                        <li className="d-inline-block me-1">
                          <a href="#">SEA BEACH</a>
                        </li>
                        <li className="d-inline-block me-1">
                          <i className="fa fa-arrow-right" />
                        </li>
                        <li className="d-inline-block me-1">
                          <a href="#">IPSUM WORLD</a>
                        </li>
                      </ul>
                      <hr />
                      <div className="profile6il2i row">
                        <div className="col-md-6">
                          <div className="profile6il2il">
                            <h6 className="font_14 mb-0">
                              Starting From:
                              <br />
                              <span className="fw-bold">
                                <span className="fs-4 col_green">$260</span>{" "}
                                <span className="text-decoration-line-through text-muted">
                                  $410
                                </span>
                              </span>
                              <br />
                              <span className="font_12">TAXES INCL/PERS</span>
                            </h6>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="profile6il2ir text-end pt-2">
                            <h6 className="mb-0">
                              <a className="button px-3" href="#">
                                Book A Trip <i className="fa fa-plane" />
                              </a>
                            </h6>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="profile6il p-3 shadow_box rounded_1">
                    <div className="profile6il1 position-relative">
                      <div className="profile6il1i">
                        <a href="#">
                          <img
                            src="img/19.jpg"
                            alt="abc"
                            className="w-100 rounded_1"
                          />
                        </a>
                      </div>
                      <div className="profile6il1i1 position-absolute top-0">
                        <h6 className="d-inline-block bg-black text-white p-2 px-3 font_14 mb-0">
                          {" "}
                          3 DAYS / 4 NIGHT
                        </h6>
                        <br />
                        <h6 className="d-inline-block bg_light p-2 px-3 font_14  mb-0">
                          <a href="#">
                            <i className="fa fa-map-marker me-1 col_green" />{" "}
                            LONDON
                          </a>
                        </h6>
                      </div>
                    </div>
                    <div className="profile6il2 mt-3">
                      <h5>
                        <a href="#">
                          Immersive Cultural Expirees, Local Cuisine.
                        </a>
                      </h5>
                      <ul className="font_12">
                        <li className="d-inline-block me-1">
                          <a href="#">LOREM PORTA</a>
                        </li>
                        <li className="d-inline-block me-1">
                          <i className="fa fa-arrow-right" />
                        </li>
                        <li className="d-inline-block me-1">
                          <a href="#">SEA BEACH</a>
                        </li>
                        <li className="d-inline-block me-1">
                          <i className="fa fa-arrow-right" />
                        </li>
                        <li className="d-inline-block me-1">
                          <a href="#">IPSUM WORLD</a>
                        </li>
                      </ul>
                      <hr />
                      <div className="profile6il2i row">
                        <div className="col-md-6">
                          <div className="profile6il2il">
                            <h6 className="font_14 mb-0">
                              Starting From:
                              <br />
                              <span className="fw-bold">
                                <span className="fs-4 col_green">$430</span>{" "}
                                <span className="text-decoration-line-through text-muted">
                                  $620
                                </span>
                              </span>
                              <br />
                              <span className="font_12">TAXES INCL/PERS</span>
                            </h6>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="profile6il2ir text-end pt-2">
                            <h6 className="mb-0">
                              <a className="button px-3" href="#">
                                Book A Trip <i className="fa fa-plane" />
                              </a>
                            </h6>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="tab-pane" id="profile10">
              <div className="profile6i row">
                <div className="col-md-4">
                  <div className="profile6il p-3 shadow_box rounded_1">
                    <div className="profile6il1 position-relative">
                      <div className="profile6il1i">
                        <a href="#">
                          <img
                            src="img/22.jpg"
                            alt="abc"
                            className="w-100 rounded_1"
                          />
                        </a>
                      </div>
                      <div className="profile6il1i1 position-absolute top-0">
                        <h6 className="d-inline-block bg-black text-white p-2 px-3 font_14 mb-0">
                          {" "}
                          1 WEEK
                        </h6>
                        <br />
                        <h6 className="d-inline-block bg_light p-2 px-3 font_14  mb-0">
                          <a href="#">
                            <i className="fa fa-map-marker me-1 col_green" />{" "}
                            EGYPT
                          </a>
                        </h6>
                      </div>
                    </div>
                    <div className="profile6il2 mt-3">
                      <h5>
                        <a href="#">
                          Discover Serenity, Exploration, And Enlightenment.
                        </a>
                      </h5>
                      <ul className="font_12">
                        <li className="d-inline-block me-1">
                          <a href="#">LOREM PORTA</a>
                        </li>
                        <li className="d-inline-block me-1">
                          <i className="fa fa-arrow-right" />
                        </li>
                        <li className="d-inline-block me-1">
                          <a href="#">SEA BEACH</a>
                        </li>
                        <li className="d-inline-block me-1">
                          <i className="fa fa-arrow-right" />
                        </li>
                        <li className="d-inline-block me-1">
                          <a href="#">IPSUM WORLD</a>
                        </li>
                      </ul>
                      <hr />
                      <div className="profile6il2i row">
                        <div className="col-md-6">
                          <div className="profile6il2il">
                            <h6 className="font_14 mb-0">
                              Starting From:
                              <br />
                              <span className="fw-bold">
                                <span className="fs-4 col_green">$340</span>{" "}
                                <span className="text-decoration-line-through text-muted">
                                  $450
                                </span>
                              </span>
                              <br />
                              <span className="font_12">TAXES INCL/PERS</span>
                            </h6>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="profile6il2ir text-end pt-2">
                            <h6 className="mb-0">
                              <a className="button px-3" href="#">
                                Book A Trip <i className="fa fa-plane" />
                              </a>
                            </h6>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="profile6il p-3 shadow_box rounded_1">
                    <div className="profile6il1 position-relative">
                      <div className="profile6il1i">
                        <a href="#">
                          <img
                            src="img/20.jpg"
                            alt="abc"
                            className="w-100 rounded_1"
                          />
                        </a>
                      </div>
                      <div className="profile6il1i1 position-absolute top-0">
                        <h6 className="d-inline-block bg-black text-white p-2 px-3 font_14 mb-0">
                          {" "}
                          2 DAYS / 3 NIGHT
                        </h6>
                        <br />
                        <h6 className="d-inline-block bg_light p-2 px-3 font_14  mb-0">
                          <a href="#">
                            <i className="fa fa-map-marker me-1 col_green" />{" "}
                            Spain
                          </a>
                        </h6>
                      </div>
                    </div>
                    <div className="profile6il2 mt-3">
                      <h5>
                        <a href="#">
                          Embracing City Lights, Landm, And Iconic Culture.
                        </a>
                      </h5>
                      <ul className="font_12">
                        <li className="d-inline-block me-1">
                          <a href="#">LOREM PORTA</a>
                        </li>
                        <li className="d-inline-block me-1">
                          <i className="fa fa-arrow-right" />
                        </li>
                        <li className="d-inline-block me-1">
                          <a href="#">SEA BEACH</a>
                        </li>
                        <li className="d-inline-block me-1">
                          <i className="fa fa-arrow-right" />
                        </li>
                        <li className="d-inline-block me-1">
                          <a href="#">IPSUM WORLD</a>
                        </li>
                      </ul>
                      <hr />
                      <div className="profile6il2i row">
                        <div className="col-md-6">
                          <div className="profile6il2il">
                            <h6 className="font_14 mb-0">
                              Starting From:
                              <br />
                              <span className="fw-bold">
                                <span className="fs-4 col_green">$260</span>{" "}
                                <span className="text-decoration-line-through text-muted">
                                  $410
                                </span>
                              </span>
                              <br />
                              <span className="font_12">TAXES INCL/PERS</span>
                            </h6>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="profile6il2ir text-end pt-2">
                            <h6 className="mb-0">
                              <a className="button px-3" href="#">
                                Book A Trip <i className="fa fa-plane" />
                              </a>
                            </h6>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="tab-pane" id="profile11">
              <div className="profile6i row">
                <div className="col-md-4">
                  <div className="profile6il p-3 shadow_box rounded_1">
                    <div className="profile6il1 position-relative">
                      <div className="profile6il1i">
                        <a href="#">
                          <img
                            src="img/19.jpg"
                            alt="abc"
                            className="w-100 rounded_1"
                          />
                        </a>
                      </div>
                      <div className="profile6il1i1 position-absolute top-0">
                        <h6 className="d-inline-block bg-black text-white p-2 px-3 font_14 mb-0">
                          {" "}
                          3 DAYS / 4 NIGHT
                        </h6>
                        <br />
                        <h6 className="d-inline-block bg_light p-2 px-3 font_14  mb-0">
                          <a href="#">
                            <i className="fa fa-map-marker me-1 col_green" />{" "}
                            LONDON
                          </a>
                        </h6>
                      </div>
                    </div>
                    <div className="profile6il2 mt-3">
                      <h5>
                        <a href="#">
                          Immersive Cultural Expirees, Local Cuisine.
                        </a>
                      </h5>
                      <ul className="font_12">
                        <li className="d-inline-block me-1">
                          <a href="#">LOREM PORTA</a>
                        </li>
                        <li className="d-inline-block me-1">
                          <i className="fa fa-arrow-right" />
                        </li>
                        <li className="d-inline-block me-1">
                          <a href="#">SEA BEACH</a>
                        </li>
                        <li className="d-inline-block me-1">
                          <i className="fa fa-arrow-right" />
                        </li>
                        <li className="d-inline-block me-1">
                          <a href="#">IPSUM WORLD</a>
                        </li>
                      </ul>
                      <hr />
                      <div className="profile6il2i row">
                        <div className="col-md-6">
                          <div className="profile6il2il">
                            <h6 className="font_14 mb-0">
                              Starting From:
                              <br />
                              <span className="fw-bold">
                                <span className="fs-4 col_green">$430</span>{" "}
                                <span className="text-decoration-line-through text-muted">
                                  $620
                                </span>
                              </span>
                              <br />
                              <span className="font_12">TAXES INCL/PERS</span>
                            </h6>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="profile6il2ir text-end pt-2">
                            <h6 className="mb-0">
                              <a className="button px-3" href="#">
                                Book A Trip <i className="fa fa-plane" />
                              </a>
                            </h6>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="tab-pane" id="profile12">
              <div className="profile6i row">
                <div className="col-md-4">
                  <div className="profile6il p-3 shadow_box rounded_1">
                    <div className="profile6il1 position-relative">
                      <div className="profile6il1i">
                        <a href="#">
                          <img
                            src="img/20.jpg"
                            alt="abc"
                            className="w-100 rounded_1"
                          />
                        </a>
                      </div>
                      <div className="profile6il1i1 position-absolute top-0">
                        <h6 className="d-inline-block bg-black text-white p-2 px-3 font_14 mb-0">
                          {" "}
                          2 DAYS / 3 NIGHT
                        </h6>
                        <br />
                        <h6 className="d-inline-block bg_light p-2 px-3 font_14  mb-0">
                          <a href="#">
                            <i className="fa fa-map-marker me-1 col_green" />{" "}
                            Spain
                          </a>
                        </h6>
                      </div>
                    </div>
                    <div className="profile6il2 mt-3">
                      <h5>
                        <a href="#">
                          Embracing City Lights, Landm, And Iconic Culture.
                        </a>
                      </h5>
                      <ul className="font_12">
                        <li className="d-inline-block me-1">
                          <a href="#">LOREM PORTA</a>
                        </li>
                        <li className="d-inline-block me-1">
                          <i className="fa fa-arrow-right" />
                        </li>
                        <li className="d-inline-block me-1">
                          <a href="#">SEA BEACH</a>
                        </li>
                        <li className="d-inline-block me-1">
                          <i className="fa fa-arrow-right" />
                        </li>
                        <li className="d-inline-block me-1">
                          <a href="#">IPSUM WORLD</a>
                        </li>
                      </ul>
                      <hr />
                      <div className="profile6il2i row">
                        <div className="col-md-6">
                          <div className="profile6il2il">
                            <h6 className="font_14 mb-0">
                              Starting From:
                              <br />
                              <span className="fw-bold">
                                <span className="fs-4 col_green">$260</span>{" "}
                                <span className="text-decoration-line-through text-muted">
                                  $410
                                </span>
                              </span>
                              <br />
                              <span className="font_12">TAXES INCL/PERS</span>
                            </h6>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="profile6il2ir text-end pt-2">
                            <h6 className="mb-0">
                              <a className="button px-3" href="#">
                                Book A Trip <i className="fa fa-plane" />
                              </a>
                            </h6>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="profile6il p-3 shadow_box rounded_1">
                    <div className="profile6il1 position-relative">
                      <div className="profile6il1i">
                        <a href="#">
                          <img
                            src="img/21.jpg"
                            alt="abc"
                            className="w-100 rounded_1"
                          />
                        </a>
                      </div>
                      <div className="profile6il1i1 position-absolute top-0">
                        <h6 className="d-inline-block bg-black text-white p-2 px-3 font_14 mb-0">
                          {" "}
                          3 DAYS / 4 NIGHT
                        </h6>
                        <br />
                        <h6 className="d-inline-block bg_light p-2 px-3 font_14  mb-0">
                          <a href="#">
                            <i className="fa fa-map-marker me-1 col_green" />{" "}
                            LONDON
                          </a>
                        </h6>
                      </div>
                    </div>
                    <div className="profile6il2 mt-3">
                      <h5>
                        <a href="#">
                          Immersive Cultural Expirees, Local Cuisine.
                        </a>
                      </h5>
                      <ul className="font_12">
                        <li className="d-inline-block me-1">
                          <a href="#">LOREM PORTA</a>
                        </li>
                        <li className="d-inline-block me-1">
                          <i className="fa fa-arrow-right" />
                        </li>
                        <li className="d-inline-block me-1">
                          <a href="#">SEA BEACH</a>
                        </li>
                        <li className="d-inline-block me-1">
                          <i className="fa fa-arrow-right" />
                        </li>
                        <li className="d-inline-block me-1">
                          <a href="#">IPSUM WORLD</a>
                        </li>
                      </ul>
                      <hr />
                      <div className="profile6il2i row">
                        <div className="col-md-6">
                          <div className="profile6il2il">
                            <h6 className="font_14 mb-0">
                              Starting From:
                              <br />
                              <span className="fw-bold">
                                <span className="fs-4 col_green">$430</span>{" "}
                                <span className="text-decoration-line-through text-muted">
                                  $620
                                </span>
                              </span>
                              <br />
                              <span className="font_12">TAXES INCL/PERS</span>
                            </h6>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="profile6il2ir text-end pt-2">
                            <h6 className="mb-0">
                              <a className="button px-3" href="#">
                                Book A Trip <i className="fa fa-plane" />
                              </a>
                            </h6>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="tab-pane" id="profile13">
              <div className="profile6i row">
                <div className="col-md-4">
                  <div className="profile6il p-3 shadow_box rounded_1">
                    <div className="profile6il1 position-relative">
                      <div className="profile6il1i">
                        <a href="#">
                          <img
                            src="img/17.jpg"
                            alt="abc"
                            className="w-100 rounded_1"
                          />
                        </a>
                      </div>
                      <div className="profile6il1i1 position-absolute top-0">
                        <h6 className="d-inline-block bg-black text-white p-2 px-3 font_14 mb-0">
                          {" "}
                          1 WEEK
                        </h6>
                        <br />
                        <h6 className="d-inline-block bg_light p-2 px-3 font_14  mb-0">
                          <a href="#">
                            <i className="fa fa-map-marker me-1 col_green" />{" "}
                            EGYPT
                          </a>
                        </h6>
                      </div>
                    </div>
                    <div className="profile6il2 mt-3">
                      <h5>
                        <a href="#">
                          Discover Serenity, Exploration, And Enlightenment.
                        </a>
                      </h5>
                      <ul className="font_12">
                        <li className="d-inline-block me-1">
                          <a href="#">LOREM PORTA</a>
                        </li>
                        <li className="d-inline-block me-1">
                          <i className="fa fa-arrow-right" />
                        </li>
                        <li className="d-inline-block me-1">
                          <a href="#">SEA BEACH</a>
                        </li>
                        <li className="d-inline-block me-1">
                          <i className="fa fa-arrow-right" />
                        </li>
                        <li className="d-inline-block me-1">
                          <a href="#">IPSUM WORLD</a>
                        </li>
                      </ul>
                      <hr />
                      <div className="profile6il2i row">
                        <div className="col-md-6">
                          <div className="profile6il2il">
                            <h6 className="font_14 mb-0">
                              Starting From:
                              <br />
                              <span className="fw-bold">
                                <span className="fs-4 col_green">$340</span>{" "}
                                <span className="text-decoration-line-through text-muted">
                                  $450
                                </span>
                              </span>
                              <br />
                              <span className="font_12">TAXES INCL/PERS</span>
                            </h6>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="profile6il2ir text-end pt-2">
                            <h6 className="mb-0">
                              <a className="button px-3" href="#">
                                Book A Trip <i className="fa fa-plane" />
                              </a>
                            </h6>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="profile6il p-3 shadow_box rounded_1">
                    <div className="profile6il1 position-relative">
                      <div className="profile6il1i">
                        <a href="#">
                          <img
                            src="img/19.jpg"
                            alt="abc"
                            className="w-100 rounded_1"
                          />
                        </a>
                      </div>
                      <div className="profile6il1i1 position-absolute top-0">
                        <h6 className="d-inline-block bg-black text-white p-2 px-3 font_14 mb-0">
                          {" "}
                          3 DAYS / 4 NIGHT
                        </h6>
                        <br />
                        <h6 className="d-inline-block bg_light p-2 px-3 font_14  mb-0">
                          <a href="#">
                            <i className="fa fa-map-marker me-1 col_green" />{" "}
                            LONDON
                          </a>
                        </h6>
                      </div>
                    </div>
                    <div className="profile6il2 mt-3">
                      <h5>
                        <a href="#">
                          Immersive Cultural Expirees, Local Cuisine.
                        </a>
                      </h5>
                      <ul className="font_12">
                        <li className="d-inline-block me-1">
                          <a href="#">LOREM PORTA</a>
                        </li>
                        <li className="d-inline-block me-1">
                          <i className="fa fa-arrow-right" />
                        </li>
                        <li className="d-inline-block me-1">
                          <a href="#">SEA BEACH</a>
                        </li>
                        <li className="d-inline-block me-1">
                          <i className="fa fa-arrow-right" />
                        </li>
                        <li className="d-inline-block me-1">
                          <a href="#">IPSUM WORLD</a>
                        </li>
                      </ul>
                      <hr />
                      <div className="profile6il2i row">
                        <div className="col-md-6">
                          <div className="profile6il2il">
                            <h6 className="font_14 mb-0">
                              Starting From:
                              <br />
                              <span className="fw-bold">
                                <span className="fs-4 col_green">$430</span>{" "}
                                <span className="text-decoration-line-through text-muted">
                                  $620
                                </span>
                              </span>
                              <br />
                              <span className="font_12">TAXES INCL/PERS</span>
                            </h6>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="profile6il2ir text-end pt-2">
                            <h6 className="mb-0">
                              <a className="button px-3" href="#">
                                Book A Trip <i className="fa fa-plane" />
                              </a>
                            </h6>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row package_1 text-center mt-5">
        <div className="col-md-12">
          <h6 className="mb-0">
            <a className="button_1" href="#">
              View All Package
            </a>
          </h6>
        </div>
      </div>
    </div>
  </section> */}
  <section id="explore_modern" className="exploreModern_section">
  <div className="container-xl">
    <div className="text-center mb-5">
      <h5 className="exploreModern_tag">
        <i className="fa fa-leaf me-1" /> Discover Verified Comfort with YOVHO{" "}
        <i className="fa fa-leaf ms-1" />
      </h5>
      <h1 className="exploreModern_title">Explore Your Perfect Stay</h1>
      <p className="exploreModern_subtitle">
        When Verified Stays Matter Most — Go With the Most Trusted.
      </p>
    </div>

    <div className="exploreModern_tabs text-center">
      <button className="exploreModern_tab active">
        <i className="fa fa-hotel" /> Hotel Stay
      </button>
      <button className="exploreModern_tab">
        <i className="fa fa-building" /> Apartment Stay
      </button>
      <button className="exploreModern_tab">
        <i className="fa fa-house-user" /> Home Stay
      </button>
      <button className="exploreModern_tab">
        <i className="fa fa-bed" /> Hostels
      </button>
    </div>

    <div className="exploreModern_cards row mt-5">
      {/* Hotel Stay */}
      <div className="col-md-6 col-lg-3 mb-4">
        <div className="exploreModern_card">
          <div className="exploreModern_image">
            <img src={About1} alt="Hotel Stay" />
          </div>
          <div className="exploreModern_content">
            <h3>Hotel Stay</h3>
            <p>
              Stay in verified hotels offering premium comfort and trusted service
              across Karachi’s top locations.
            </p>
            <ul>
              <li>✔ Verified Properties</li>
              <li>✔ Premium Facilities</li>
            </ul>
            <a href="#" className="exploreModern_btn">Check Availability</a>
          </div>
        </div>
      </div>

      {/* Apartment Stay */}
      <div className="col-md-6 col-lg-3 mb-4">
        <div className="exploreModern_card">
          <div className="exploreModern_image">
            <img src={About2} alt="Apartment Stay" />
          </div>
          <div className="exploreModern_content">
            <h3>Apartment Stay</h3>
            <p>
              Enjoy modern, family-friendly apartments designed for both short and
              long stays.
            </p>
            <ul>
              <li>✔ Fully Furnished</li>
              <li>✔ Family-Friendly</li>
            </ul>
            <a href="#" className="exploreModern_btn">Check Availability</a>
          </div>
        </div>
      </div>

      {/* Home Stay */}
      <div className="col-md-6 col-lg-3 mb-4">
        <div className="exploreModern_card">
          <div className="exploreModern_image">
            <img src={About3} alt="Home Stay" />
          </div>
          <div className="exploreModern_content">
            <h3>Home Stay</h3>
            <p>
              Feel like a local with verified homestays offering authentic hospitality
              and comfort.
            </p>
            <ul>
              <li>✔ Local Hosts</li>
              <li>✔ Home Comforts</li>
            </ul>
            <a href="#" className="exploreModern_btn">Check Availability</a>
          </div>
        </div>
      </div>

      {/* Hostels */}
      <div className="col-md-6 col-lg-3 mb-4">
        <div className="exploreModern_card">
          <div className="exploreModern_image">
            <img src={About4} alt="Hostel Stay" />
          </div>
          <div className="exploreModern_content">
            <h3>Hostels</h3>
            <p>
              Budget-friendly comfort and community vibes for solo travelers and
              students.
            </p>
            <ul>
              <li>✔ Clean & Secure</li>
              <li>✔ Prime Locations</li>
            </ul>
            <a href="#" className="exploreModern_btn">Check Availability</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

 







  {/* <ReviewSection /> */}













  {/* <section id="testim" className="p_3 bg_light1 carousel_p px_4">
    <div className="container-fluid">
      <div className="row vacation_1 text-center mb-4">
        <div className="col-md-12">
          <h5 className="family_1 icon_tag col_green">
            <i className="fa fa-leaf me-1" /> Testimonial{" "}
            <i className="fa fa-leaf ms-1" />
          </h5>
          <h1 className="font_50 mt-3 mb-0">Regards From Travelers</h1>
        </div>
      </div>
      <div className="testim_1 row">
        <div
          id="carouselExampleCaptions1"
          className="carousel slide"
          data-bs-ride="carousel"
        >
          <div className="carousel-indicators">
            <button
              type="button"
              data-bs-target="#carouselExampleCaptions1"
              data-bs-slide-to={0}
              className="active"
              aria-label="Slide 1"
            />
            <button
              type="button"
              data-bs-target="#carouselExampleCaptions1"
              data-bs-slide-to={1}
              aria-label="Slide 2"
              className=""
              aria-current="true"
            />
          </div>
          <div className="carousel-inner">
            <div className="carousel-item active">
              <div className="testim_1i row">
                <div className="col-md-4">
                  <div className="testim_1il">
                    <div className="testim_1il1 bg-white rounded_1 p-4  text-center">
                      <p>
                        "Absolute perfection! Egens Lab's web development
                        services left me completely satisfied and eager to
                        recommend them to others."
                      </p>
                      <div className="testim_1il1i row">
                        <div className="col-md-4">
                          <div className="testim_1il1il pt-4">
                            <h5 className="font_14 mb-0">
                              <i className="fa fa-umbrella col_green me-1" />{" "}
                              Tripadvisor
                            </h5>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="testim_1il1im text-center">
                            <span className="font_60 lh-1 text-light">
                              <i className="fa fa-quote-right" />
                            </span>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="testim_1il1ir pt-3">
                            <h5 className="font_14 lh-base mb-0">
                              May 9, 2023 <br />
                              <span className="text-muted fw-normal">
                                10.30 PM
                              </span>
                            </h5>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="testim_1il2 mt-4">
                      <img
                        src="img/4.jpg"
                        className="float-start rounded-circle me-3"
                        alt="abc"
                      />
                      <h4 className="mb-0 lh-1">
                        Lorem Amet <br />{" "}
                        <span className="font_14 text-muted fw-normal">
                          France
                        </span>
                      </h4>
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="testim_1il">
                    <div className="testim_1il1 bg-white rounded_1 p-4  text-center">
                      <p>
                        "Absolute perfection! Egens Lab's web development
                        services left me completely satisfied and eager to
                        recommend them to others."
                      </p>
                      <div className="testim_1il1i row">
                        <div className="col-md-4">
                          <div className="testim_1il1il pt-4">
                            <h5 className="font_14 mb-0">
                              <i className="fa fa-umbrella col_green me-1" />{" "}
                              Tripadvisor
                            </h5>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="testim_1il1im text-center">
                            <span className="font_60 lh-1 text-light">
                              <i className="fa fa-quote-right" />
                            </span>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="testim_1il1ir pt-3">
                            <h5 className="font_14 lh-base mb-0">
                              May 8, 2023 <br />
                              <span className="text-muted fw-normal">
                                10.39 PM
                              </span>
                            </h5>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="testim_1il2 mt-4">
                      <img
                        src="img/5.jpg"
                        className="float-start rounded-circle me-3"
                        alt="abc"
                      />
                      <h4 className="mb-0 lh-1">
                        Ipsum Porta <br />{" "}
                        <span className="font_14 text-muted fw-normal">
                          London
                        </span>
                      </h4>
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="testim_1il">
                    <div className="testim_1il1 bg-white rounded_1 p-4  text-center">
                      <p>
                        "Absolute perfection! Egens Lab's web development
                        services left me completely satisfied and eager to
                        recommend them to others."
                      </p>
                      <div className="testim_1il1i row">
                        <div className="col-md-4">
                          <div className="testim_1il1il pt-4">
                            <h5 className="font_14 mb-0">
                              <i className="fa fa-umbrella col_green me-1" />{" "}
                              Tripadvisor
                            </h5>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="testim_1il1im text-center">
                            <span className="font_60 lh-1 text-light">
                              <i className="fa fa-quote-right" />
                            </span>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="testim_1il1ir pt-3">
                            <h5 className="font_14 lh-base mb-0">
                              May 7, 2023 <br />
                              <span className="text-muted fw-normal">
                                11.20 PM
                              </span>
                            </h5>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="testim_1il2 mt-4">
                      <img
                        src="img/6.jpg"
                        className="float-start rounded-circle me-3"
                        alt="abc"
                      />
                      <h4 className="mb-0 lh-1">
                        Dolor Quis <br />{" "}
                        <span className="font_14 text-muted fw-normal">
                          Spain
                        </span>
                      </h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="carousel-item">
              <div className="testim_1i row">
                <div className="testim_1i row">
                  <div className="col-md-4">
                    <div className="testim_1il">
                      <div className="testim_1il1 bg-white rounded_1 p-4  text-center">
                        <p>
                          "Absolute perfection! Egens Lab's web development
                          services left me completely satisfied and eager to
                          recommend them to others."
                        </p>
                        <div className="testim_1il1i row">
                          <div className="col-md-4">
                            <div className="testim_1il1il pt-4">
                              <h5 className="font_14 mb-0">
                                <i className="fa fa-umbrella col_green me-1" />{" "}
                                Tripadvisor
                              </h5>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="testim_1il1im text-center">
                              <span className="font_60 lh-1 text-light">
                                <i className="fa fa-quote-right" />
                              </span>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="testim_1il1ir pt-3">
                              <h5 className="font_14 lh-base mb-0">
                                May 9, 2023 <br />
                                <span className="text-muted fw-normal">
                                  10.30 PM
                                </span>
                              </h5>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="testim_1il2 mt-4">
                        <img
                          src="img/4.jpg"
                          className="float-start rounded-circle me-3"
                          alt="abc"
                        />
                        <h4 className="mb-0 lh-1">
                          Lorem Amet <br />{" "}
                          <span className="font_14 text-muted fw-normal">
                            France
                          </span>
                        </h4>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="testim_1il">
                      <div className="testim_1il1 bg-white rounded_1 p-4  text-center">
                        <p>
                          "Absolute perfection! Egens Lab's web development
                          services left me completely satisfied and eager to
                          recommend them to others."
                        </p>
                        <div className="testim_1il1i row">
                          <div className="col-md-4">
                            <div className="testim_1il1il pt-4">
                              <h5 className="font_14 mb-0">
                                <i className="fa fa-umbrella col_green me-1" />{" "}
                                Tripadvisor
                              </h5>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="testim_1il1im text-center">
                              <span className="font_60 lh-1 text-light">
                                <i className="fa fa-quote-right" />
                              </span>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="testim_1il1ir pt-3">
                              <h5 className="font_14 lh-base mb-0">
                                May 8, 2023 <br />
                                <span className="text-muted fw-normal">
                                  10.39 PM
                                </span>
                              </h5>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="testim_1il2 mt-4">
                        <img
                          src="img/5.jpg"
                          className="float-start rounded-circle me-3"
                          alt="abc"
                        />
                        <h4 className="mb-0 lh-1">
                          Ipsum Porta <br />{" "}
                          <span className="font_14 text-muted fw-normal">
                            London
                          </span>
                        </h4>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="testim_1il">
                      <div className="testim_1il1 bg-white rounded_1 p-4  text-center">
                        <p>
                          "Absolute perfection! Egens Lab's web development
                          services left me completely satisfied and eager to
                          recommend them to others."
                        </p>
                        <div className="testim_1il1i row">
                          <div className="col-md-4">
                            <div className="testim_1il1il pt-4">
                              <h5 className="font_14 mb-0">
                                <i className="fa fa-umbrella col_green me-1" />{" "}
                                Tripadvisor
                              </h5>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="testim_1il1im text-center">
                              <span className="font_60 lh-1 text-light">
                                <i className="fa fa-quote-right" />
                              </span>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="testim_1il1ir pt-3">
                              <h5 className="font_14 lh-base mb-0">
                                May 7, 2023 <br />
                                <span className="text-muted fw-normal">
                                  11.20 PM
                                </span>
                              </h5>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="testim_1il2 mt-4">
                        <img
                          src="img/6.jpg"
                          className="float-start rounded-circle me-3"
                          alt="abc"
                        />
                        <h4 className="mb-0 lh-1">
                          Dolor Quis <br />{" "}
                          <span className="font_14 text-muted fw-normal">
                            Spain
                          </span>
                        </h4>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section> */}















  <section id="blogShowcase" className="blogShowcase_wrapper">
      <div className="container-xl">
        {/* Header */}
        <div className="blogShowcase_header text-center mb-5">
          <h5 className="blogShowcase_tag">
            <i className="fa fa-leaf me-2"></i> Latest Blog{" "}
            <i className="fa fa-leaf ms-2"></i>
          </h5>
          <h2 className="blogShowcase_title">Latest Travel Blog</h2>
          <p className="blogShowcase_subtitle">
            Explore inspiring travel stories, tips, and hidden gems from around the world.
          </p>
        </div>

        {/* Blog Grid */}
        <div className="row g-4 align-items-stretch">
          {/* Left Featured Blog */}
          <div className="col-md-5">
            <div className="blogShowcase_featured">
              <div className="blogShowcase_imgWrap">
                <img src={Offer1} alt="Main blog" className="blogShowcase_img" />
              </div>
              <div className="blogShowcase_content">
                <ul className="blogShowcase_meta">
                  <li>By Admin</li>
                  <li>Feb 6, 2024</li>
                  <li>3 Comments</li>
                </ul>
                <h4 className="blogShowcase_heading">
                  Spiritual Sojourn: Pilgrimage Tours For Soul Seekers
                </h4>
                <div className="blogShowcase_footer">
                  <a href="#" className="blogShowcase_read">
                    View Post <i className="fa fa-arrow-right ms-1"></i>
                  </a>
                  <div className="blogShowcase_socials">
                    <i className="fa-brands fa-facebook"></i>
                    <i className="fa-brands fa-pinterest"></i>
                    <i className="fa-brands fa-instagram"></i>
                    <i className="fa-brands fa-linkedin"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Right Blog Cards */}
          <div className="col-md-7">
            {[ 
              { img: Offer2, date: "7 Feb", title: "Wine Country Escapes: Vineyard Tours For Connoisseurs", read: "1 Min Read" },
              { img: Offer3, date: "8 Feb", title: "Thrills & Chills: Extreme Sports Tours For Adrenaline Junkies", read: "2 Min Read" },
              { img: Saddar, date: "9 Feb", title: "Urban Wanderlust: City Walking Tours For Street Savvy", read: "3 Min Read" }
            ].map((b, i) => (
              <div className="blogShowcase_card" key={i}>
                <div className="blogShowcase_cardImg position-relative">
                  <img src={b.img} alt={b.title} className="w-100" />
                  <div className="blogShowcase_date">{b.date}</div>
                </div>
                <div className="blogShowcase_cardBody">
                  <ul className="blogShowcase_meta small">
                    <li>By TravelPro</li>
                    <li>Adventure Safari</li>
                  </ul>
                  <h5 className="blogShowcase_cardTitle">{b.title}</h5>
                  <div className="blogShowcase_cardFooter">
                    <a href="#" className="blogShowcase_read">
                      View Post <i className="fa fa-arrow-right ms-1"></i>
                    </a>
                    <span className="blogShowcase_readtime">
                      <i className="fa fa-fire me-1 text-success"></i> {b.read}
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>

















  {/* <section id="serv_h" className="p_3">
    <div className="container-xl">
      <div className="row vacation_1 text-center mb-4">
        <div className="col-md-12">
          <h5 className="family_1 icon_tag col_green">
            <i className="fa fa-leaf me-1" /> Visa Services{" "}
            <i className="fa fa-leaf ms-1" />
          </h5>
          <h1 className="font_50 mt-3 mb-0">Visa Processing</h1>
        </div>
      </div>
      <div className="row serv_h1">
        <div className="col-md-4">
          <div className="serv_h1l position-relative">
            <div className="serv_h1l1">
              <a href="#">
                <img
                  src="img/41.jpg"
                  className="w-100 rounded_top rounded_bottom"
                  alt="abc"
                />
              </a>
            </div>
            <div className="serv_h1l2 position-absolute text-center w-100 top-0 px-3">
              <h4 className="d-inline-block bg_green text-white p-3 px-5 rounded_5">
                {" "}
                London
              </h4>
            </div>
            <div className="serv_h1l3 bg_back position-absolute bottom-0 w-100 rounded_bottom">
              <div className="serv_h1l3i row">
                <div className="col-md-6">
                  <div className="serv_h1l3il text-center p-3 pt-5">
                    <h5 className="mb-0 text-white">Electronic</h5>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="serv_h1l3ir text-center p-3">
                    <h2 className="text-white mb-0">
                      $6756 <br />{" "}
                      <span className="text-decoration-line-through text-white-50 fs-6">
                        $7765
                      </span>{" "}
                    </h2>
                    <h6 className="mb-0 font_14 text-white-50">Per Person</h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-4">
          <div className="serv_h1l position-relative">
            <div className="serv_h1l1">
              <a href="#">
                <img
                  src="img/42.jpg"
                  className="w-100 rounded_top rounded_bottom"
                  alt="abc"
                />
              </a>
            </div>
            <div className="serv_h1l2 position-absolute text-center w-100 top-0 px-3">
              <h4 className="d-inline-block bg_green text-white p-3 px-5 rounded_5">
                {" "}
                Italy
              </h4>
            </div>
            <div className="serv_h1l3 bg_back position-absolute bottom-0 w-100 rounded_bottom">
              <div className="serv_h1l3i row">
                <div className="col-md-6">
                  <div className="serv_h1l3il text-center p-3 pt-5">
                    <h5 className="mb-0 text-white">Electronic</h5>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="serv_h1l3ir text-center p-3">
                    <h2 className="text-white mb-0">
                      $5256 <br />{" "}
                      <span className="text-decoration-line-through text-white-50 fs-6">
                        $6765
                      </span>{" "}
                    </h2>
                    <h6 className="mb-0 font_14 text-white-50">Per Person</h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-4">
          <div className="serv_h1l position-relative">
            <div className="serv_h1l1">
              <a href="#">
                <img
                  src="img/43.jpg"
                  className="w-100 rounded_top rounded_bottom"
                  alt="abc"
                />
              </a>
            </div>
            <div className="serv_h1l2 position-absolute text-center w-100 top-0 px-3">
              <h4 className="d-inline-block bg_green text-white p-3 px-5 rounded_5">
                {" "}
                London
              </h4>
            </div>
            <div className="serv_h1l3 bg_back position-absolute bottom-0 w-100 rounded_bottom">
              <div className="serv_h1l3i row">
                <div className="col-md-6">
                  <div className="serv_h1l3il text-center p-3 pt-5">
                    <h5 className="mb-0 text-white">Spain</h5>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="serv_h1l3ir text-center p-3">
                    <h2 className="text-white mb-0">
                      $4256 <br />{" "}
                      <span className="text-decoration-line-through text-white-50 fs-6">
                        $5325
                      </span>{" "}
                    </h2>
                    <h6 className="mb-0 font_14 text-white-50">Per Person</h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section> */}
  {/* <div className="main_footer position-relative">
    <div className="main_footer1 position-absolute w-100">
      <section id="join" className="p_3">
        <div className="container-xl">
          <div className="row join_1 shadow_box pt-5 pb-5 mx-0 bg-white">
            <div className="col-md-3">
              <div className="join_1l">
                <img src="img/44.jpg" className="w-100" alt="abc" />
              </div>
            </div>
            <div className="col-md-6">
              <div className="join_1m text-center">
                <h1>Join The Newsletter</h1>
                <p>To receive our best monthly deals</p>
                <div className="input-group">
                  <input
                    type="text"
                    className="form-control rounded-0 font_14"
                    placeholder="Enter Your Email..."
                  />
                  <span className="input-group-btn">
                    <button
                      className="btn btn-primary bg_green rounded-0 p-3 px-4  border-0"
                      type="button"
                    >
                      <i className="fa fa-arrow-right" />{" "}
                    </button>
                  </span>
                </div>
              </div>
            </div>
            <div className="col-md-3">
              <div className="join_1l">
                <img src="img/44.jpg" className="w-100" alt="abc" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    

  </div> */}
</>



















        
          </div>
        )
    }
}

export default Home;